import { FeatureItemList, FeatureItemType } from './FeaturesTable.interfaces';

const QR_CODE_FEATURES: FeatureItemList = [
  {
    feature: 'QR scans per month',
    free: '100',
    id: 1,
    plan: 'Plan limit',
    tooltip: 'QR scans per month',
    type: FeatureItemType.text,
  },
  {
    feature: 'Unlimited QR codes per project',
    free: true,
    id: 2,
    plan: true,
    tooltip: 'Unlimited QR codes per project',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Unlimited campaigns / spaces',
    free: true,
    id: 3,
    plan: true,
    tooltip: '',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Customise QR code colours',
    free: true,
    id: 4,
    plan: true,
    tooltip: 'Customise QR code colours',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Download QR codes in SVG, PNG, JPG formats',
    free: true,
    id: 5,
    plan: true,
    tooltip: 'Download QR codes in SVG, PNG, JPG formats',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Increased engagement',
    free: true,
    id: 6,
    plan: true,
    tooltip: 'Increased engagement',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Fast and affordable',
    free: true,
    id: 7,
    plan: true,
    tooltip: 'Fast and affordable',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Free tier & Pay-per-use',
    free: true,
    id: 8,
    plan: true,
    tooltip: 'Free tier & Pay-per-use',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Realtime editing: Update QR code meta data, while maintaining the same QR code',
    free: false,
    id: 9,
    plan: true,
    tooltip: 'Realtime editing: Update QR code meta data, while maintaining the same QR code',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Create codes to open uploaded documents and images',
    free: false,
    id: 10,
    plan: true,
    tooltip: 'Create codes to open uploaded documents and images',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Installation support and education',
    free: false,
    id: 11,
    plan: true,
    tooltip: 'Installation support and education',
    type: FeatureItemType.checked,
  },
];

const SUPPORT_FEATURES: FeatureItemList = [
  {
    feature: 'Team members',
    free: '1 member',
    id: 1,
    plan: 'Unlimited',
    tooltip: '',
    type: FeatureItemType.text,
  },
  {
    feature: 'Online chat',
    free: true,
    id: 2,
    plan: true,
    tooltip: '',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Email support',
    free: true,
    id: 3,
    plan: true,
    tooltip: '',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Installation support and education',
    free: false,
    id: 4,
    plan: true,
    tooltip: '',
    type: FeatureItemType.checked,
  },
  {
    feature: 'Phone support',
    free: '-',
    id: 5,
    plan: 'Enterprise',
    tooltip: '',
    type: FeatureItemType.text,
  },
];
export { QR_CODE_FEATURES, SUPPORT_FEATURES };
